import type { SearchableField } from "@salon/types";

export const WEB_PAGE_SEARCH: SearchableField[] = [
  {
    id: "web_page.hero_banner",
    sectionId: "web-page",
    labelKey: "search.webPage.heroBanner.label",
    descriptionKey: "search.webPage.heroBanner.description",
    keywordsKey: "search.webPage.heroBanner.keywords",
    anchor: "field-web-hero-banner",
  },
  {
    id: "web_page.announcement",
    sectionId: "web-page",
    labelKey: "search.webPage.announcement.label",
    descriptionKey: "search.webPage.announcement.description",
    keywordsKey: "search.webPage.announcement.keywords",
    anchor: "field-web-announcement",
  },
  {
    id: "web_page.social_links",
    sectionId: "web-page",
    labelKey: "search.webPage.socialLinks.label",
    descriptionKey: "search.webPage.socialLinks.description",
    keywordsKey: "search.webPage.socialLinks.keywords",
    anchor: "field-web-social-links",
  },
];
